import { Button as e } from "../Button/Button.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import n from "./Calendar.module.js";
import { useMemo as r, useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import { CaretLeftIcon as c, CaretRightIcon as l } from "@phosphor-icons/react";
//#region lib/components/DatePicker/MonthCalendar.tsx
var u = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
function d({ month: d, onMonthChange: f, onSelectMonth: p, selectedMonth: m }) {
	let [h, g] = i(() => (d ?? /* @__PURE__ */ new Date()).getFullYear()), _ = d?.getFullYear() ?? h, v = r(() => {
		let e = [];
		for (let t = 0; t < u.length; t += 3) e.push(u.slice(t, t + 3));
		return e;
	}, []), y = (e) => {
		let t = _ + e;
		g(t);
		let n = new Date(t, d?.getMonth() ?? 0, 1);
		f?.(n);
	};
	return /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ s("div", {
		className: n.monthHeader,
		children: [
			/* @__PURE__ */ o(t, {
				onClick: () => {
					y(-1);
				},
				"aria-label": "Previous year",
				icon: /* @__PURE__ */ o(c, { size: 24 }),
				shape: "pill",
				color: "neutral"
			}),
			/* @__PURE__ */ o("div", {
				className: n.monthHeaderLabel,
				children: _
			}),
			/* @__PURE__ */ o(t, {
				onClick: () => {
					y(1);
				},
				"aria-label": "Next year",
				icon: /* @__PURE__ */ o(l, { size: 24 }),
				shape: "pill",
				color: "neutral"
			})
		]
	}), /* @__PURE__ */ o("div", {
		className: n.monthGrid,
		children: v.map((t) => /* @__PURE__ */ o("div", {
			className: n.monthRow,
			children: t.map((t) => {
				let r = u.indexOf(t), i = m ? m.getFullYear() === _ && m.getMonth() === r : !1;
				return /* @__PURE__ */ o(e, {
					className: n.monthButton,
					color: "neutral",
					size: "md",
					label: t,
					onClick: () => {
						p(r, _);
					},
					noBorder: !i
				}, t);
			})
		}, t.join("-")))
	})] });
}
//#endregion
export { d as MonthCalendar };
